import React from 'react';

import {
	Icon,
	styled
} from 'ps-gui';
import { getPhrase } from '../data/phrases';

const Prefix = styled.span`
	font-weight: 400;
`;

const Number = styled.span`
	font-weight: 700;
`;

const Hours = styled.div`
	font-size: 14px;
	text-align: right;
`;

const Wrapper = styled.a`
	font-size: 16px;
	position: relative;
	vertical-align: middle;
	display: inline-block;
	.icon {
		margin-right: 4px;
		position: relative;
		top: -1px;
		&[data-name=phonebig] {
			top: -3px;
			margin-right: 8px;
		}
	}
	text-decoration: none;
	&:hover {
		* {
			text-decoration: underline;
		}

	}
	color: ${props => props.theme.textColor};
	margin: ${props => props.margin};

	&.light {
		* {
			font-weight: 300;
		}
	}
`;


export default class PhoneNumber extends React.PureComponent {
	render() {
		let value = this.props.value;
		if (this.props.preset === 'intergram') {
			//value = '+420602615292';
			value = '+420221871929';
		}
		if (!value) {
			return null;
		}
		return (
			<Wrapper href={'tel:' + value} margin={this.props.margin} className={'phoneNumber ' + (this.props.light ? 'light' : 'normal')}>
				<Icon
					name={this.props.bigIcon ? 'phonebig' : 'phone'}
				/>
				<Prefix>{value.substring(0, 4)+'\u00A0'}</Prefix>
				<Number>{value.substring(4, 7)+'\u00A0'}</Number>
				<Number>{value.substring(7, 10)+'\u00A0'}</Number>
				<Number>{value.substring(10)}</Number>
				{
					this.props.withHours && <Hours>{getPhrase('phoneHours')}</Hours>
				}
			</Wrapper>
		);
	}
}
